export default __webpack_public_path__ + "static/ico-eksperci-4b887fee41b5f46b5dbef13b22086303.svg";